import { AnchorHTMLAttributes, MutableRefObject } from 'react'
import { Link } from 'react-router-dom'

import { ClassProps } from '@/common/util/props'

interface Props extends ClassProps, AnchorHTMLAttributes<HTMLAnchorElement> {
  link: string
  anchorRef?: MutableRefObject<HTMLAnchorElement>
}

const InternalLink = ({ children, link, className, anchorRef, ...props }: Props) => {
  return (
    <Link {...props} className={className} to={link} ref={anchorRef}>
      {children}
    </Link>
  )
}

export default InternalLink
